import React from 'react';
import { Section, Block, BlockHero } from './ContentBlocks';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import Gallery from '@browniebroke/gatsby-image-gallery';

export const ParagraphRenderer = ({ block }: { block: Block }) => (
  <div className="prose py-4">
    <BlockHero block={block} className="aspect-video rounded-lg" />

    {!!block.heading && <h2 className="mb-0 font-medium">{block.heading}</h2>}
    {!!block.subheading && (
      <h3 className="my-0 font-medium text-primary-700 opacity-90">
        {block.subheading}
      </h3>
    )}
    {!!block.body && (
      <div
        className="max-w-prose text-base"
        dangerouslySetInnerHTML={{
          __html: block.body.childMarkdownRemark.html,
        }}
      />
    )}
    {block.galleryImages?.length > 0 && (
      <Gallery images={block.galleryImages} />
    )}
  </div>
);

export const ParagraphSection = ({ section }: { section: Section }) => {
  return (
    <div>
      {section.blocks.map((b) => (
        <ParagraphRenderer key={b.id} block={b} />
      ))}
    </div>
  );
};
